/**
 * Charlie's display constants. `BUCKET_LABELS` names the MOCK fixtures' bucket
 * keys — live suggestions carry their own label, the SP's `SignalCategoryName`,
 * because the categories are administered in the database and the UI cannot
 * hold a closed list of them.
 */
import type { BucketKey, CharlieService } from "@/components/charlie/types";

export const BUCKET_LABELS: Record<BucketKey, string> = {
  staffing: "Staffing — Utilization & Productivity",
  noa: "NOA Filing Due",
  lupa: "LUPA Risk — Scheduling Required",
  soc: "SOC to Be Scheduled",
  payor: "Payor Alerts",
  orders: "Orders Awaiting Signature",
  clinical: "Clinical Review",
  hope: "HOPE Due",
  hsoc: "SOC to Be Scheduled",
  longstay: "Long-Stay Review",
  hclinical: "Clinical Review",
};

/**
 * TEMPORARY — the branch Charlie opens on.
 *
 * "All my branches" sends `@BranchSystemID = NULL`, and `[Charlie].[GetTasks]`
 * returns nothing for a NULL branch rather than every branch, so landing on it
 * shows an empty brief. This is also the only branch that currently has any
 * signal tasks seeded.
 *
 * DELETE THIS once the SP grows an all-branches path — the default goes back to
 * "all", which is the honest landing state for an administrator. Related: the
 * branch-ID shim in the backend's `charlieService.ts`, same root cause.
 */
export const DEFAULT_BRANCH_SYSTEM_ID = "SKY-01-Y81";

/** How many buckets start expanded on load. */
export const OPEN_BUCKETS_ON_LOAD = 3;

export const SERVICE_LABEL: Record<CharlieService, string> = {
  hh: "Home Health",
  hos: "Hospice",
};

/** "2026-09-02" → "Sep 2". The `T00:00` pins the date to local midnight so a
 *  date-only string doesn't slide a day backwards in negative-offset zones. */
export const fmtDate = (d?: string): string =>
  d ? new Date(d + "T00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "";
